<template>
    <div class="d-flex h-100">
        <b-card
            header="Prisijunkite"
            class="m-auto w-100 rounded-0"
            variant="dark"
            id="login-card"
        >
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                id="input-group-1"
                label="El. paštas:"
                label-for="input-1"
            >
                <!-- description="We'll never share your email with anyone else." -->
                <b-form-input
                    id="input-1"
                    v-model="email"
                    type="email"
                    required
                    placeholder="Jūsų el. pašto adresas"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                id="input-group-2"
                label="Slaptažodis:"
                label-for="input-2"
            >
                <b-form-input
                    id="input-2"
                    v-model="password"
                    type="password"
                    required
                    placeholder="Jūsų slaptažodis"
                ></b-form-input>
            </b-form-group>

            <b-form-group>
                <b-button @click="login">Prisijungti</b-button>
            </b-form-group>

            <p class="small text-muted">
                Dar neturite paskyros? Jūs galite
                <router-link to="/sign-up">registruotis čia</router-link>
            </p>
        </b-card>
    </div>
</template>

<script>
// import firebase from "firebase";
// import { mapActions } from "vuex";

export default {
    name: "login",
    data() {
        return {
            email: "",
            password: ""
        };
    },
    methods: {
        // ...mapActions({
        //   setUser: "auth/setUser"
        // }),
        login: function() {
            // firebase
            //   .auth()
            //   .signInWithEmailAndPassword(this.email, this.password)
            //   .then(
            //     user => {
            //       this.setUser({
            //         user: { email: user.user.email, uid: user.user.uid }
            //       });
            //     },
            //     err => {
            //       alert("Oops. " + err.message);
            //     }
            //   );
        }
    }
};
</script>

<style scoped>
#login-card {
    max-width: 500px;
}
</style>
